<kpi4me-checkbox-element
  [data]="checkboxData"
  [formControlElement]="hasRepo"
  (modelChange)="onHasRepoChanged($event)"
/>

<kpi4me-text-element
  [formControlElement]="formGuid"
  [data]="textElementData"
  [matAutocomplete]="auto"
/>
<mat-autocomplete
  #auto="matAutocomplete"
  class="guid-autocomplete"
>
  @for (suggestion of guidSuggestions; track suggestion.value) {
    <mat-option [value]="suggestion.value">
      <span class="guid-suggestion-key">{{ suggestion.key }}</span>
      <span class="guid-suggestion-separator">&nbsp;&ndash;&nbsp;</span>
      <span class="guid-suggestion-value">{{ suggestion.value }}</span>
    </mat-option>
  }
</mat-autocomplete>

@if (render) {
  @if (hasRepo.value) {
    <kpi4me-form-wrapper
      [GUID]="formGuid.value"
    />
  } @else {
    <lib-guid-form-control
      [standardForm]="true"
      [inputGUID]="formGuid.value"
      (instanceInitialized)="onInizializedDynamicFormControl($event)"
    />
  }
}
